import React, { useState } from 'react';
import styled from 'styled-components';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { VenueFilterData } from '../../../shared/dto/EntityRepository';
import belowIcon from '../../../asset/icon/below.png';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import { useExhibitionVenueActions } from '../../../shared/hooks/useApi/useExhibitionVenue';
import { useExhibitionVenueStore } from '../../../shared/store/exhibitionVenueStore';
import FilterStationVenueType from '../../../admin/component/venues/FilterStationVenueType';
import FilterStationVenueAdmission from '../../../admin/component/venues/FilterStationVenueAdmission';
import FilterStationVenueOpenToday from '../../../admin/component/venues/FilterStationVenueOpenToday';

const ExhibitionFilterStationModalMobile: React.FC = () => {
  const { clearModal } = useModalStore();
  const filterData = useExhibitionVenueStore((state) => state.filterData);
  const { setFilterData } = useExhibitionVenueActions();
  const [currentFilter, setCurrentFilter] = useState<VenueFilterData>(filterData);

  if (!filterData) return null;

  const handleSubmit = () => {
    setFilterData(currentFilter);
    clearModal(400);
  };

  const handleClose = () => {
    clearModal(400);
  };

  return (
    <FilterStationComp>
      <TitleWrapper>
        <FilterStationTitle>{getModalMessage('FILTER_STATION_TITLE')}</FilterStationTitle>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent={true}
          backgroundImg={belowIcon}
          onClick={handleClose}
          aria-label="Close"
        />
      </TitleWrapper>
      <FilterContent>
        <FilterStationVenueType
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationVenueAdmission
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationVenueOpenToday
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
      </FilterContent>
      <HeadlessBtn
        value={getBtnName('APPLY')}
        handleClick={handleSubmit}
        StyledBtn={ApplyButton}
      />
    </FilterStationComp>
  );
};

const FilterStationComp = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  max-height: 95vh;
`;

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const FilterStationTitle = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;


const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  padding-bottom: 20px;
`;

const ApplyButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

export default ExhibitionFilterStationModalMobile;
